import type { ReactNode } from "react";

import { EnterprisePlusModal } from "../EnterprisePlusModal";
import { useShouldShowEnterprisePlusModal } from "../hooks/useShouldShowEnterprisePlusModal";
import type { UpgradePlanProviderProps } from "../UpgradePlanContext";
import { UpgradePlanProvider } from "../UpgradePlanContext";

export interface UpgradePlanModalComponentProps {
  onCloseModal?: () => void | Promise<void>;
  onSuccess?: () => void | Promise<void>;
  subheading?: string;
  successButtonLabel?: string;
}

export interface UpgradePlanModalWrapperProps
  extends
    Omit<UpgradePlanProviderProps, "children">,
    UpgradePlanModalComponentProps {
  children: (props: UpgradePlanModalComponentProps) => ReactNode;
  isRenewal?: boolean;
  shouldSkipProrationStep?: boolean;
}

export const UpgradePlanModalWrapper = ({
  planTier,
  subheading,
  source,
  conversationUuid,
  onSuccess,
  successButtonLabel,
  shouldSkipEmailHubReload,
  usedForWorkflows,
  isEmailHubRequired,
  showPlanDetails = false,
  planId,
  onCloseModal,
  shouldSkipProrationStep = false,
  isRenewal = false,
  children,
}: UpgradePlanModalWrapperProps) => {
  const shouldShowEnterprisePlusModal =
    useShouldShowEnterprisePlusModal(planTier);

  if (shouldShowEnterprisePlusModal) {
    return <EnterprisePlusModal onClose={onCloseModal} source={source} />;
  }

  return (
    <UpgradePlanProvider
      planTier={planTier}
      planId={planId}
      source={source}
      conversationUuid={conversationUuid}
      usedForWorkflows={usedForWorkflows}
      isEmailHubRequired={isEmailHubRequired}
      showPlanDetails={showPlanDetails}
      shouldSkipProrationStep={shouldSkipProrationStep}
      isRenewal={isRenewal}
      shouldSkipEmailHubReload={shouldSkipEmailHubReload}
    >
      {children({ subheading, onSuccess, successButtonLabel, onCloseModal })}
    </UpgradePlanProvider>
  );
};
